import { SportPartnersPage } from "./page";

export default SportPartnersPage;
